import { Box, Flex, rem, Text } from 'affiny-ui/src';
import React, { useState } from 'react';
import { Link } from 'react-scroll';

interface IPersonalityReportLayerSubMenuItem {
  activeTitle: string;
  title: string;
  index: number;
  nbOfItem: number;
  hash: string;
}

const PersonalityReportLayerSubMenuItem = ({
  title,
  nbOfItem,
  index,
  hash,
  activeTitle,
}: IPersonalityReportLayerSubMenuItem) => {
  const [onHover, setOnHover] = useState(false);
  const isSelected = hash === activeTitle;

  return (
    <Flex
      justifyContent="flex-start"
      alignItems="center"
      width="100%"
      onMouseEnter={() => setOnHover(true)}
      onMouseLeave={() => setOnHover(false)}
      flexGrow={0}
      cursor="pointer"
    >
      <Box
        height="100%"
        width={rem(4)}
        backgroundColor={isSelected ? 'accent' : 'gallery'}
        borderTopRightRadius={index === 0 ? rem(4) : null}
        borderTopLeftRadius={index === 0 ? rem(4) : null}
        borderBottomRightRadius={index === nbOfItem ? rem(4) : null}
        borderBottomLeftRadius={index === nbOfItem ? rem(4) : null}
      />
      <Link to={hash} offset={-200}>
        <Text
          fontSize="size16"
          maxWidth={310}
          my="small"
          ml="medium"
          color={isSelected ? 'accent' : onHover ? 'primary' : 'secondary'}
          fontWeight={600}
        >
          {title}
        </Text>
      </Link>
    </Flex>
  );
};

export default PersonalityReportLayerSubMenuItem;
